import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import { getApi } from '../../../api/endpoints.js';
import Page from "../../Page.js";
import FormPartial from './FormPartial.js';
import PageContentWrapper from "../../../components/PageContentWrapper.js";
import uiManager from '../../../../config/ui.js';
import PAGES from '../../../data/PagesConstants.js';
import RollOverConfig from '../../../models/RollOverConfig.js';
import { toast } from 'react-toastify';

const Edit = () => {
  const [rollOverConfig, setRollOverConfig] = useState((new RollOverConfig()).toStateJson());
  const rollOverConfigObj = new RollOverConfig(rollOverConfig);
  const [leaseOfferDetails, setLeaseOfferDetails] = useState({});
  const [getLeaseOfferDetailsApi] = getApi('showLeaseOffer');
  const [updateApi] = getApi('updateRollOverConfig');
  const [fetchApi] = getApi('showRollOverConfig');
  const navigate = useNavigate();
  const params = useParams();

  useEffect(() => {
    makeApiCalls();
  }, []);

  const makeApiCalls = async () => {
    await getLeaseOfferDetails();
    await getRecord({ id: params.rollover_config_id })
  }

  const getLeaseOfferDetails = async () => {
    try{
      let response = await getLeaseOfferDetailsApi({id: params.id}).unwrap();
      setLeaseOfferDetails(response.data.lease_offer);
    } catch(error) {
      toast.error(error.data?.message || "Something went wrong!")
    }
  }

  const getRecord = async (params) => {
    try {
      let response = await fetchApi({ id: params.id }).unwrap();
      setRollOverConfig((new RollOverConfig(response.data.rollover_config, 1)).toStateJson());
    } catch(error) {
      toast.error(error.data?.message || "Something Went Wrong !")
    }
  }

  const updateRecord = async (params) => {
    try {
      await updateApi(params).unwrap();
      navigate(-1);
      toast.success("Rollover Configuartion Updated Successfully");
    } catch(error) {
      rollOverConfigObj.set_api_errors(error?.data?.data?.errors);
      toast.error(error?.data?.message || "Something went wrong");
    }
  }

  const onUpdateClick = () => {
    try{
      updateRecord((new RollOverConfig(rollOverConfig)).toEditApiJson());
    } catch(error){
      setRollOverConfig(new RollOverConfig(rollOverConfig));
    }
  }

  const onBackClick = () => {
    navigate(-1);
  }

  return <Page
    uiPage={uiManager.getUiPage(PAGES.EditRollOverConfigPage.name)}
    breadcrumbs={[
      { label: "Home", url: '/dashboard' },
      { label: "Fleet Owners", url: `/fleet_owners` },
      { label: `${params.fleet_owner_id}`, url: `/fleet_owners/${params.fleet_owner_id}` },
      { label: `Lease Offers`, url: `/fleet_owners/${params.fleet_owner_id}` },
      { label: `${params.id}`, url: `/fleet_owners/${params.fleet_owner_id}` },
      { label: `Rollover Configurations`, url: `/fleet_owners/${params.fleet_owner_id}/lease_offers/${params.id}/rollover_configs` },
      { label: `${params.rollover_config_id}`, url: `/fleet_owners/${params.fleet_owner_id}/lease_offers/${params.id}/rollover_configs` },
      { label: "Edit" }
    ]}
    className={'rollover-config-edit-page'}
  >
    <PageContentWrapper contentHeading={`Edit RollOver Configuration For Lease Offer ${leaseOfferDetails.name}`}>
      <div className='m-3'>
        <form className="row g-4" autoComplete="off">
          <FormPartial rollOverConfig={rollOverConfig} setRollOverConfig={setRollOverConfig} />
          <div className='mb-4 col-md-12'>
            <div>
              <button type="button" className="btn btn-voltup-theme" onClick={onBackClick} style={{ float: 'inline-start' }}>
                Back
              </button>
              <button type="button" className="btn btn-voltup-theme ms-3" onClick={onUpdateClick}>
                Update Rollover Configuration
              </button>
            </div>
          </div>
        </form>
      </div>
    </PageContentWrapper>
  </Page>
};

export default Edit;
